module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P-P30"
  }), _vm._v(" "), _c('p', {
    staticClass: "P-P25"
  }), _vm._v(" "), _c('p', {
    staticClass: "P-P25"
  }), _vm._v(" "), _c('p', {
    staticClass: "P-P12"
  }, [_c('span', {
    staticClass: "S-huge"
  }, [_c('span', {
    staticClass: "S-T"
  }, [_vm._v("Life is not a series of gig lamps symmetrically arranged; life is a luminous halo, a semi-transparent envelope surrounding us from the beginning of consciousness to the end.")])]), _c('span', {
    staticClass: "S-T"
  }, [_c('br', {
    staticClass: "calibre3"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "P-P31"
  }, [_c('span', {
    staticClass: "S-huge"
  }, [_c('span', {
    staticClass: "S-T"
  }, [_vm._v("Virginia Woolf")])])]), _vm._v(" "), _c('p', {
    staticClass: "P-P31"
  }), _vm._v(" "), _c('p', {
    staticClass: "P-P31"
  }), _vm._v(" "), _c('p', {
    staticClass: "P-P31"
  }), _vm._v(" "), _c('p', {
    staticClass: "P-P32"
  }, [_vm._v("I have been astonished that men could die martyrs for their religion – I have shudder’d at it. I shudder no more. I could be martyr’d for my religion. Love is my religion and I could die for that.  I could die for you.")]), _vm._v(" "), _c('p', {
    staticClass: "P-P33"
  }, [_c('br', {
    staticClass: "calibre3"
  }), _vm._v("\n  John Keats")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5ff7c0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0004.vue
// module id = 69
// module chunks = 0